module.exports = __webpack_public_path__ + "img/04_sub_no.de27aa48.svg";